import { SVGProps } from 'react';

export default function BoxPlusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none" {...props}>
      <path
        d="M25.0286 20.0525V7.35082L14.0285 1L3.02856 7.35082V20.0525L14.0285 26.4034L25.0286 20.0525Z"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.02856 7.35107L14.0285 13.702M14.0285 13.702L25.0286 7.35107M14.0285 13.702V26.4037"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0286 19C16.79 19 19.0286 16.7614 19.0286 14C19.0286 11.2386 16.79 9 14.0286 9C11.2671 9 9.02856 11.2386 9.02856 14C9.02856 16.7614 11.2671 19 14.0286 19Z"
        fill="white"
        stroke="#29845A"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M14.0286 11.5298V16.4677M16.4976 13.9987H11.5597"
        stroke="#29845A"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
